<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <DStoreNav></DStoreNav>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="estore-body">
                <div id="activation-page" class="estore-content">
                    <b-row>
                        <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                        <div class="filter-wrapper">
                            <b-form-select
                                v-model="filter.selected"
                                :options="filter.options"
                                @input="setParam" />
                        </div>
                        </b-col>
                        <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                            <div class="filter-wrapper">
                                <b-input-group prepend>
                                    <b-form-input
                                        placeholder="Search"
                                        v-model="keyword"
                                        @input="setParam">
                                    </b-form-input>
                                    <b-dropdown text="Advanced" variant="primary" slot="append">
                                        <b-dropdown-item>
                                            
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group>
                            </div>
                        </b-col>
                        <b-col class="text-left text-md-right customers-wrapper" style="min-height: initial;">
                            <span class="csv-tooltip">
                                CSV <b-link class="template-button" :href="csvUrl">(Template)</b-link>
                                <b-btn variant="ghost" v-b-popover.hover="'Import or export list of your customers in excel CSV format'" title="">
                                    <i class="ic-tooltip" id="csv"></i>
                                </b-btn>
                            </span>
                            <b-form-file
                                v-model="importCsv"
                                hidden
                                accept=".csv"
                                ref="importCsv">
                            </b-form-file>
                            <b-button
                                class="mr-3"
                                variant="tertiary btn-table-import-activation-key"
                                @click="openModal">
                                Import
                            </b-button>
                            <b-button variant="tertiary btn-table-export-activation-key d-none" @click="exportHistory">Export</b-button>
                        </b-col>
                    </b-row>
                    <div class="customers-wrapper">
                        <ActivationKeyList :id="null" />
                        <Pagination />
                        <b-modal
                            id="upload-file"
                            title="Upload File"
                            ref="uploadFileModal"
                            hide-footer
                            centered>
                            <b-container fluid id="upload-file-container">
                                <p class="text-center">Download a sample <b-link class="template-button" :href="csvUrl">CSV template</b-link>to see an example of the format required.</p>
                                <div class="modal-form">
                                    <b-form class="mb-2">
                                        <div id="file-input-container" class="p-3 mb-2" v-bind:class="{ 'hide-label': files.length > 0 }">
                                            <b-form-file 
                                                v-model="files" 
                                                ref="fileinput" 
                                                multiple 
                                                accept=".csv" 
                                                placeholder="Drop your file here or "
                                                v-on:input="onChange"
                                                :disabled="filesAccumulated.length == 1"
                                            >
                                            </b-form-file>
                                        </div>
                                        <hr>
                                        <b-form-group
                                            :invalid-feedback="errorMessage('activation_keys')"
                                            :state="isValid('activation_keys')"
                                        >
                                        </b-form-group>
                                        <div v-if="filesAccumulated.length > 0">
                                            <div v-bind:class="{ 'd-none': filesAccumulated.length == 0 }" class="mb-4" v-for="(file, index) in filesAccumulated" :key="index">
                                                    <div class="d-inline-block file-name-container">
                                                        <img class="d-inline-block upload-file-icon" width="16" height="20" src="@/assets/images/icons/ic-upload-file.svg" alt="">
                                                        <div class="ml-2 d-inline-block upload-file-name">
                                                            {{ file.name }}
                                                        </div>
                                                    </div>
                                                    <div class="d-inline-block cancel-file-upload-container">
                                                        <span>{{ formatBytes(file) }}</span>
                                                        <img width="15" height="15" src="@/assets/images/icons/cancel-file-upload.svg" alt="" @click="cancelFileUpload(index)" class="cancel-file-upload-icon">
                                                    </div>
                                                    <p v-if="!acceptFileSize" class="text-center" style="color: red;">File size exceeds 1MB. Please reduce the file size and reupload.</p>
                                                    <p v-if="!acceptFileType" class="text-center" style="color: red;">Incorrect file format. Please upload a CSV file.</p>
                                                    <b-form-group
                                                        label="Product List"
                                                        class="mb-0"
                                                    >
                                                    </b-form-group>
                                                    <b-card no-body class="mb-1" >
                                                        <b-card-header header-tag="header" class="p-1" role="tab" style="background: #ffffff;">
                                                            <b-row no-gutters>
                                                                <b-col>{{ activation_keys[index].product_name }}</b-col>
                                                                <b-col cols="1">
                                                                    <div
                                                                        v-b-toggle="'accordion-' + index"
                                                                        class="action-button text-right"
                                                                    >
                                                                        <img
                                                                            src="@/assets/images/icons/collapse.svg"
                                                                            alt="Collapsed Icon"
                                                                            class="d-inline-block mr-2 when-closed"
                                                                            style="width: 14px; height: 14px;"
                                                                        />
                                                                        <img
                                                                            src="@/assets/images/icons/expand.svg"
                                                                            alt="Expand Icon"
                                                                            class="d-inline-block mr-2 when-opened"
                                                                            style="width: 14px; height: 14px;"
                                                                        />
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card-header>
                                                        <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                                                            <b-card-body class="p-0" :key="componentKey">
                                                                <b-input-group>
                                                                    <b-input-group
                                                                        slot="prepend"
                                                                        class="border px-2 d-flex align-items-center"
                                                                    >
                                                                        <img
                                                                            src="@/assets/images/actions/search.svg"
                                                                            alt="Search Icon"
                                                                            style="width: 24px; height: 24px;"
                                                                        />
                                                                    </b-input-group>
                                                                    <b-form-input 
                                                                        placeholder="Search"
                                                                        style="border-radius: 0px; border-right: 0px; border-top: 0px;"
                                                                        v-model="paramProductOptions.payload.search.keyword"
                                                                        @input="setParamProductOptions"
                                                                    ></b-form-input>
                                                                </b-input-group>
                                                                <template v-if="loading || dstoreInventoriesIsLoading">
                                                                    <p class="text-center">Loading...</p>    
                                                                </template>
                                                                <template v-else>
                                                                    <b-form-select v-model="activation_keys[index].product_uuid" @scroll.native="loadProductList" :select-size="5" style="border: 0px;"  @change="getProductName(index)">
                                                                        <option v-for="(productOption, productOptionIndex) in productOptions" :key="productOptionIndex" :value="productOption.uuid">
                                                                            {{ productOption.name }}
                                                                        </option>
                                                                    </b-form-select>
                                                                </template>
                                                            </b-card-body>
                                                        </b-collapse>
                                                    </b-card>
                                                    <b-form-group
                                                        :invalid-feedback="errorMessage('activation_keys.' + index + '.product_uuid')"
                                                        :state="isValid('activation_keys.' + index + '.product_uuid')"
                                                    >
                                                    </b-form-group>
                                            </div>
                                        </div>
                                    </b-form>
                                    <img class="d-inline-block upload-file-folder-icon" width="42" height="42" src="@/assets/images/icons/ic-folder.svg" alt="">
                                    <label class="shown-label" v-bind:class="{ 'd-none': files.length == 0 }" @click="openFileSelection()">Drop your file here or <span>browse</span></label>
                                    <b-btn variant="tertiary" v-bind:disabled="loading" @click="closeModal()" style="border-radius: 20px; width: 89.13px; height: 40px;">
                                        Cancel
                                    </b-btn>
                                    <b-btn variant="primary" v-bind:disabled="loading || filesAccumulated.length === 0 || !acceptFileSize || !acceptFileType" @click="uploadFile" class="float-right" style="border-radius: 20px; width: 102.13px; height: 40px;">
                                        <template v-if="loading">
                                            Uploading...
                                        </template>
                                        <template v-else>
                                            Upload
                                        </template>
                                    </b-btn>
                                </div>
                            </b-container>
                        </b-modal>
                        <div class="notification-success-import">
                            <notifications width="445px" classes="notif-import" group="success-import" position="bottom left"/>
                        </div>
                        <div class="notification-upload-import">
                            <notifications width="445px" classes="upload-import" group="uploading-import" position="bottom right"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import DStoreNav from "./DStoreNav";
import ActivationKeyList from "./activation-key/ActivationKeyTable";
import Pagination from "./activation-key/Pagination";

export default {
    components: {
        DStoreNav,
        ActivationKeyList,
        Pagination
    },
    computed: {
        ...mapState("dstoreActivationKeys", {
            loading: state => state.loading,
            errors: state => state.errors,
            dstoreActivationKeysParam: state => state.param,
            importUuid: state => state.importUuid,
            importUuids: state => state.importUuids
        }),
        ...mapState("dstoreInventories", {
            productOptions: state => state.productOptions,
            dstoreInventoriesIsLoading: state => state.loading,
            maxPage: state => state.maxPage
        })
    },
    data() {
        return {
            env: process.env.VUE_APP_MODE,
            csvUrl: "",
            baseUrl: process.env.VUE_APP_API,
            interval: null,
            importCsv: null,
            files: [],
            acceptFileType: true,
            acceptFileSize: true,
            filesAccumulated: [],
            activation_keys: [],
            importInProgressUuids: [],
            importCompleteUuids: [],
            keyword: "",
            param: {
                page: 1,
                // payload: {
                //     keyword: ""
                // }
            },
            paramProductOptions: {
                page: 1,
                payload: {
                    search: {
                        // paired_key: "all",
                        keyword: ""
                        // column: "all"
                    }
                }
            },
            filter: {
                selected: "All Codes",
                options: [
                    { value: 'All Codes', text: 'All Codes' },
                    { value: 'Date - Newest to Oldest', text: 'Date - Newest to Oldest' },
                    { value: 'Date - Oldest to Newest', text: 'Date - Oldest to Newest' },
                    { value: 'Codes - A to Z', text: 'Codes - A to Z' },
                    { value: 'Codes - Z to A', text: 'Codes - Z to A' },
                    { value: 'Status - Available', text: 'Status - Available' },
                    { value: 'Status – Sent', text: 'Status – Sent' },
                ],
            },
            componentKey: 0
        };
    },
    methods: {
        generateCsvUrl() {
            this.csvUrl =
                this.baseUrl +
                "dstore-service/v1/api/public/dstore/product/activation/key/template";
        },
        clearProductOptions: async function() {
            this.param.page = 1;
            this.paramProductOptions.payload.search.keyword = "";
            // await this.$store.dispatch(
            //     "dstoreInventories/getProductOptions",
            //     this.paramProductOptions
            // );
            this.$store.commit("dstoreInventories/clearProductOptions");
        },
        getProductOptions: async function() {
            await this.$store.dispatch(
                "dstoreInventories/getProductOptions",
                this.paramProductOptions
            );
        },
        showNotification(importStatus) {
            if (importStatus.data.import_status == "ongoing") {
                if (
                    !this.importInProgressUuids.includes(
                        importStatus.data.import_code
                    )
                ) {
                    this.importInProgressUuids.push(
                        importStatus.data.import_code
                    );
                    this.$notify({
                        id: importStatus.data.import_code,
                        group: "uploading-import",
                        title:
                            "<div class='lds-circle'><div></div></div> <span class='uploading'>Uploading</span> <i class='icon-close' id='upload-close-" +
                            importStatus.data.import_code +
                            "' ></i>",
                        duration: -10
                    });
                }
            } else if (importStatus.data.import_status == "completed") {
                this.importInProgressUuids = this.importInProgressUuids.filter(
                    uuid => uuid !== importStatus.data.import_code
                );
                let closeUploadNotifRef =
                    "upload-close-" + importStatus.data.import_code; //  Get UUID of close button of upload notification
                if (document.getElementById(closeUploadNotifRef) != null) {
                    // Close upload notification if it's done
                    document.getElementById(closeUploadNotifRef).click();
                }
                if (
                    !this.importCompleteUuids.includes(
                        importStatus.data.import_code
                    )
                ) {
                    this.importCompleteUuids.push(
                        importStatus.data.import_code
                    );
                    // let titleToBeShown = "";
                    // console.log(importStatus.data.failed_count);
                    // if (importStatus.data.failed_count >= 1) {
                    //     titleToBeShown =
                    //         "<i class='icon-success'></i>" +
                    //         importStatus.data.import_message +
                    //         "</span> <a class='download-csv' href='" +
                    //         this.baseUrl +
                    //         "transactions-service/transaction/merchant/import/failed/" +
                    //         importStatus.data.import_code +
                    //         "'>Download Result</a><i class='icon-close'></i>";
                    // } else {
                    //     titleToBeShown =
                    //         "<i class='icon-success'></i>" +
                    //         importStatus.data.import_message +
                    //         "</span> <i class='icon-close-without-download-link'></i>";
                    // }

                    let titleToBeShown =
                        "<i class='icon-success'></i>" +
                        importStatus.message +
                        "</span> <i class='icon-close-without-download-link'></i>";

                    this.$notify({
                        id: "success-import" + importStatus.data.import_code,
                        group: "success-import",
                        title: titleToBeShown,
                        duration: 60000
                    });
                }
                //  Remove UUID from importUuids
                this.$store.dispatch(
                    "dstoreActivationKeys/removeUuidFromImportUuids",
                    importStatus.data.import_code
                );
                // Refresh the table after uploading
                this.getActivationKeys();
            }
        },
        getActivationKeys: async function() {
            if (this.id == null) {
                let param = {
                    page: 1
                };
                this.$store.commit("dstoreActivationKeys/setParam", param);
                await this.$store.dispatch(
                    "dstoreActivationKeys/getActivationKeys",
                    this.param
                );
            } else {
                let param = {
                    page: 1,
                    payload: {
                        filters: {
                            keyword: "",
                            product_add_on_uuid: this.id
                        }
                    }
                };
                this.$store.commit("dstoreActivationKeys/setParam", param);
                await this.$store.dispatch(
                    "dstoreActivationKeys/getActivationKeys",
                    this.param
                );
            }
        },
        async checkInitialImportStatus() {
            let _this = this;
            await this.$store
                .dispatch(
                    "dstoreActivationKeys/getImportsStatus",
                    _this.importUuid
                )
                .then(function(importStatus) {
                    if (importStatus.data.import_status == "ongoing") {
                        _this.importInProgressUuids.push(
                            importStatus.data.import_code
                        );
                        _this.$notify({
                            id: importStatus.data.import_code,
                            group: "uploading-import",
                            title:
                                "<div class='lds-circle'><div></div></div> <span class='uploading'>Uploading</span> <i class='icon-close' id='upload-close-" +
                                importStatus.data.import_code +
                                "' ></i>",
                            duration: -10
                        });
                    }
                });
        },
        async checkImportStatus() {
            // console.log(this.importUuids);
            if (this.importUuids.length > 0) {
                this.interval = window.setInterval(() => {
                    for (
                        let index = 0;
                        index < this.importUuids.length;
                        index++
                    ) {
                        let _this = this;
                        const element = this.importUuids[index];
                        this.$store
                            .dispatch(
                                "dstoreActivationKeys/getImportsStatus",
                                element
                            )
                            .then(function(data) {
                                _this.showNotification(data);
                            });
                    }
                }, 15000);
            } else {
                clearInterval(this.interval);
            }
        },
        openFileSelection() {
            if (this.filesAccumulated.length < 1) {
                this.$refs.fileinput.$el.childNodes[0].click();
            }
        },
        async uploadFile() {
            this.$store.dispatch("dstoreActivationKeys/resetErrors");

            if (this.filesAccumulated.length > 0) {
                for (
                    let index = 0;
                    index < this.filesAccumulated.length;
                    index++
                ) {
                    const fileInBase64 = this.filesAccumulated[index]
                        ? await this.getBase64(this.filesAccumulated[index])
                        : null;
                    this.activation_keys[index].file = fileInBase64
                        ? fileInBase64.split("base64,").pop()
                        : null;
                }
            }

            let param = {
                activation_keys: this.activation_keys.filter(activation_key => {
                    return activation_key.file != "";
                })
            };

            let _this = this;
            await this.$store
                .dispatch("dstoreActivationKeys/importActivationKeys", param)
                .then(function() {
                    if (_this.errors == null) {
                        _this.checkInitialImportStatus();
                        _this.checkImportStatus();
                        _this.$refs.uploadFileModal.hide();
                        _this.$refs.fileinput.reset();
                        _this.files = [];
                        _this.activation_keys = [];
                        _this.$store.dispatch(
                            "dstoreActivationKeys/getActivationKeys",
                            _this.dstoreActivationKeysParam
                        );
                    }
                });
        },
        exportHistory() {
            let range_param =
                this.range == null ? null : this.getRange(this.range);

            let searchable =
                this.searchString == "" ? null : this.getSearchable();

            let search_param =
                searchable == null
                    ? null
                    : {
                          category: this.selectedSearchOption,
                          text: searchable
                      };

            let param = {
                filter: range_param,
                search: search_param
            };

            this.$store.dispatch("transactions/exportHistory", param);
        },
        formatBytes(file, decimals = 2) {
            if (file != null) {
                if (file.size === 0) return "0 Bytes";

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = [
                    "Bytes",
                    "KB",
                    "MB",
                    "GB",
                    "TB",
                    "PB",
                    "EB",
                    "ZB",
                    "YB"
                ];

                const i = Math.floor(Math.log(file.size) / Math.log(k));

                return (
                    parseFloat((file.size / Math.pow(k, i)).toFixed(dm)) +
                    " " +
                    sizes[i]
                );
            }
        },
        async getBase64(file, onLoadCallback) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors[field] ? false : true;
        },
        closeModal() {
            this.$refs.uploadFileModal.hide();
        },
        openModal() {
            this.$store.dispatch("dstoreActivationKeys/resetErrors");
            this.$refs.fileinput.reset();
            this.files = [];
            this.filesAccumulated = [];
            this.activation_keys = [];
            this.$refs.uploadFileModal.show();
            this.acceptFileType = true;
            this.acceptFileSize = true;
            this.componentKey += 1;
        },
        loadProductList(e) {
            if (
                e.target.offsetHeight + e.target.scrollTop >=
                e.target.scrollHeight - 1
            ) {
                if (this.param.page > 1 && !this.products) return;

                if (this.param.page < this.maxPage) {
                    this.param.page++;
                    this.getProductOptions();
                }
            }
        },
        cancelFileUpload(index) {
            if (index > -1) {
                this.filesAccumulated.splice(index, 1);
            }
            this.acceptFileType = true;
            this.acceptFileSize = true;
        },
        onChange() {
            this.files.forEach(thisFile => {
                this.filesAccumulated.push(thisFile);
            });
        },
        setParam: async function() {
            let param = {
                page: 1,
                payload: {
                    filters: {
                        keyword: this.keyword
                    }
                }
            }

            switch (this.filter.selected) {
                // case 'All Codes':
                //     param.payload.filters.sort_by = "";
                //     param.payload.filters.sort_value = "";
                //     param.payload.filters.sort = "";
                //     break;
                case 'Date - Newest to Oldest':
                    param.payload.filters.sort_by = "date_uploaded";
                    param.payload.filters.sort = "desc";
                    break;
                case 'Date - Oldest to Newest':
                    param.payload.filters.sort_by = "date_uploaded";
                    param.payload.filters.sort = "asc";
                    break;
                case 'Codes - A to Z':
                    param.payload.filters.sort_by = "code";
                    param.payload.filters.sort = "asc";
                    break;
                case 'Codes - Z to A':
                    param.payload.filters.sort_by = "code";
                    param.payload.filters.sort = "desc";
                    break;
                case 'Status - Available':
                    param.payload.filters.sort_by = "status";
                    param.payload.filters.sort_value = "available ";
                    // param.payload.filters.sort = "";
                    break;
                case 'Status – Sent':
                    param.payload.filters.sort_by = "status";
                    param.payload.filters.sort_value = "sent";
                    // param.payload.filters.sort = "";
                    break;
                default:
                    break;
            }

            this.$store.commit("dstoreActivationKeys/setParam", param);
            await this.$store.dispatch(
                "dstoreActivationKeys/getActivationKeys",
                this.dstoreActivationKeysParam
            );
        },
        setParamProductOptions: async function() {
            this.paramProductOptions.page = 1;
            await this.$store.dispatch(
                "dstoreInventories/getProductOptions",
                this.paramProductOptions
            );
        },
        getProductName(index) {
            let product = this.productOptions.find(
                productOption =>
                    productOption.uuid ===
                    this.activation_keys[index].product_uuid
            );
            this.activation_keys[index].product_name = product.name;
        },
        checkFileType(file) {
            if (
                file.type !== "application/vnd.ms-excel" &&
                file.type !== ".csv" &&
                file.type !== "text/csv"
            ) {
                this.acceptFileType = false;
            } else {
                this.acceptFileType = true;
            }
            // console.log(this.acceptFileType);
        },
        checkFileSize(file) {
            if (file.size / 1024 / 1024 > 1) {
                this.acceptFileSize = false;
            } else {
                this.acceptFileSize = true;
            }
            // console.log(this.acceptFileSize);
        }
    },
    watch: {
        filesAccumulated: function(filesAccumulated) {
            if (filesAccumulated.length > 1) {
                for (let index = 1; index < filesAccumulated.length; index++) {
                    if (
                        filesAccumulated.indexOf(filesAccumulated[index]) > -1
                    ) {
                        filesAccumulated.splice(index, 1);
                    }
                }
            }

            if (filesAccumulated.length == 1) {
                this.checkFileType(filesAccumulated[0]);
                this.checkFileSize(filesAccumulated[0]);
            }

            for (let index = 0; index < filesAccumulated.length; index++) {
                this.activation_keys.push({
                    product_name: "",
                    product_uuid: "",
                    file: ""
                });
            }
        }
    },
    created: function() {
        this.generateCsvUrl();
        this.clearProductOptions();
        this.getProductOptions();
    }
};
</script>

<style lang="scss">
.btn-primary.disabled,
.btn-primary:disabled {
    background-color: #ccc7c4;
    border-color: #ccc7c4;
}
.icon-close-without-download-link {
    right: -195px !important;
}
.customers-wrapper
    #upload-file
    #upload-file-container
    .upload-file-folder-icon {
    z-index: 9;
    left: 125px;
    top: 89px;
    position: absolute;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none !important;
}
.customers-wrapper #upload-file #upload-file-container .shown-label {
    position: absolute;
    top: 101px;
    left: 175px;
    z-index: 9;
    font-size: 14px;
    font-family: MainFontRegular, sans-serif !important;
    color: #495057;
}
.lds-circle {
    top: 4px;
    position: relative;
    display: inline-block;
    transform: translateZ(1px);
}
.lds-circle > div {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 8px;
    border-radius: 50%;
    background: #ff8828;
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
@keyframes lds-circle {
    0%,
    100% {
        animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
        transform: rotateY(0deg);
    }
    50% {
        transform: rotateY(1800deg);
        animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
        transform: rotateY(3600deg);
    }
}
</style>
